import { useI18n } from "../../i18n/I18nProvider";
import { paths } from "../../lib/endpoints";

export interface PersonThumbProps {
  workspaceId: string;
  mediaId: string | null;
  name: string;
}

/** 48px photo thumb. Without a photo: a blue-wash square with the initial in condensed blue. */
export function PersonThumb({ workspaceId, mediaId, name }: PersonThumbProps) {
  const { t } = useI18n();
  if (!mediaId) {
    return (
      <div className="hidden size-12 shrink-0 items-center justify-center rounded-[10px] bg-blue-wash sm:flex">
        <span aria-hidden="true" className="font-display text-xl font-extrabold text-blue">
          {name.slice(0, 1).toUpperCase()}
        </span>
        <span className="sr-only">{t("roster.noPhoto")}</span>
      </div>
    );
  }
  return (
    <img
      src={paths.mediaFile(workspaceId, mediaId)}
      alt={name}
      loading="lazy"
      className="hidden size-12 shrink-0 rounded-[10px] bg-ice-2 object-cover sm:block"
    />
  );
}
